import styled from "@emotion/styled";

export const IntegrationsLayoutBottomBuffer = styled.div`
  display: block;
  height: 200px;
  min-height: 200px;
`;
